import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkModule } from '@app/directives/link.directive';
import { MarkComponentVisitedModule } from '@app/directives/mark-component-visited.directive';
import { FeaturedNewsModule } from '@app/components/featured-news/featured-news.component';
import { MyNewsModule } from '@app/components/my-news/my-news.component';
import { MyAppTilesModule } from '@app/components/apps-and-tools/my-app-tiles/my-app-tiles.component';
import { SmartLinksModule } from '@app/components/smart-links/smart-links.component';
import { HideParentIfEmptyModule } from '@app/directives/hide-parent-if-empty.directive';
import { KpiChartsModule } from '@app/components/kpi-charts/kpi-charts.component';
import { InfoboxZoneModule } from '@app/components/infobox-zone/infobox-zone.component';

@Component({
  selector: 'wplight-today',
  templateUrl: './today-light.component.html',
  styleUrls: ['./today-light.component.scss']
})
export class TodayLightComponent {
}
@NgModule({
  declarations: [TodayLightComponent],
  exports: [TodayLightComponent],
  imports: [
    CommonModule,
    LinkModule,
    MyAppTilesModule,
    SmartLinksModule,
    HideParentIfEmptyModule,
    FeaturedNewsModule,
    MyNewsModule,
    MarkComponentVisitedModule,
    KpiChartsModule,
    InfoboxZoneModule
  ]
})
export class TodayLightModule { }
